import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-035ebb58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "queue-deleted__content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "queue-deleted__title" }, "Очередь удалена", -1))

import { TirPmIconView } from 'tir-components';
import { TrashIcon } from 'tir-style-system/icons/outline';

export default /*#__PURE__*/_defineComponent({
  __name: 'queue-deleted',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TirPmIconView), {
      size: 80,
      colorCode: "#FFEBEB",
      isBordered: false
    }, {
      mainSlot: _withCtx(() => [
        _createVNode(_unref(TrashIcon), { class: "queue-deleted__icon" })
      ]),
      _: 1
    }),
    _hoisted_2
  ]))
}
}

})